module.exports = __webpack_public_path__ + "img/bg_3.3a692b7f.png";